<template>
  <div id="PaymentInstructions">
    <p
      style="
        font-size: 0.1rem;
        color: #94acba;
        margin: 0.12rem 0 0 0;
        font-family: Regular;
        text-align: center;
      "
    >
      {{ $t("nav.buyConfigPaytitle")
      }}<a
        href="https://alchemypay.org/terms-of-use/"
        style="cursor: pointer; color: rgba(0, 71, 173, 1)"
        >{{ $t("menu.service") }}</a
      >
      {{ $t("nav.code_and") }}
      <a
        style="cursor: pointer; color: rgba(0, 71, 173, 1)"
        href="https://alchemypay.org/privacy-policy/"
        >{{ $t("nav.code_name2") }}.</a
      >
    </p>
    <p
      style="
        font-family: Regular;
        color: #94acba;
        font-size: 0.1rem;
        text-align: center;
        font-weight: 400;
        margin-top: 0.08rem;
      "
      v-if="status"
    >
      Alchemy GPS Europe UAB with address at J. Basanavičiaus g. 26, LT-03224,
      Vilnius, Lithuania
    </p>
  </div>
</template>

<script>
/**
 * 支付协议文案、公司地址文案
 */

export default {
  name: "Payment-Instructions",
  props: ["status"],
};
</script>
